import { QuoteSetupItems } from '@/models/cart'
import { MapElementWithSectorId } from '@/models/map'
import { QuoteReservation } from '@/models/quote'
import { Service } from '@/models/service'
import { getBoughtServicesTotal } from './timeSchedules'

export function getSelectedElementTicketQuantity({
  selectedElementQuotableProducts,
  ticketServices,
}: {
  selectedElementQuotableProducts: QuoteSetupItems
  ticketServices: Service[]
}): number {
  const ticketIds = new Set(ticketServices.map((service) => service.serviceId))

  return Object.entries(selectedElementQuotableProducts.boughtServices).reduce(
    (carry, [key, boughtService]) => {
      const serviceId = Number(key)
      if (ticketIds.has(serviceId)) {
        return carry + getBoughtServicesTotal(boughtService)
      }
      return carry
    },
    0
  )
}

export function getMapTicketGlobalQuantity({
  cartReservations,
  selectedElement,
  selectedElementQuotableProducts,
  ticketServices,
}: {
  cartReservations: QuoteReservation[]
  selectedElement: MapElementWithSectorId
  selectedElementQuotableProducts: QuoteSetupItems
  ticketServices: Service[]
}): number {
  const ticketIds = new Set(ticketServices.map((service) => service.serviceId))

  const cartReservationsExcludingSelectedElement = cartReservations.filter(
    (reservation) =>
      reservation.spotName !== selectedElement.name ||
      reservation.spotType !== selectedElement.subType
  )

  const totalInCart = cartReservationsExcludingSelectedElement.reduce(
    (carry, reservation) => {
      return (
        carry +
        Object.entries(reservation.boughtServices).reduce(
          (groupCarry, [key, boughtService]) => {
            const serviceId = Number(key)
            if (ticketIds.has(serviceId)) {
              return groupCarry + getBoughtServicesTotal(boughtService)
            }
            return groupCarry
          },
          0
        )
      )
    },
    0
  )

  const totalInSelectedElement = getSelectedElementTicketQuantity({
    selectedElementQuotableProducts,
    ticketServices,
  })

  return totalInCart + totalInSelectedElement
}
